var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { NotificationTypeV1, } from '@oneaudi/audi-notification-display-service';
import { useI18n, useI18nBulk } from '@oneaudi/i18n-context';
import { TextLink } from '@oneaudi/unified-web-components';
import React, { createContext, useContext, useEffect, useMemo, useState, } from 'react';
import { useServicesContext } from '../../context';
import { useAuthContext } from './AuthContext';
export const MyAudiWishlistContext = createContext({});
export const MyAudiWishlistContextProvider = ({ children, }) => {
    const { authService, isAuthenticated, isAuthenticating } = useAuthContext();
    const localeService = useServicesContext().getAdditionalService('gfa:locale-service');
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState();
    const [wishlist, setWishlist] = useState([]);
    useEffect(() => {
        if (!isAuthenticated) {
            if (!isAuthenticating)
                setIsLoading(false);
            return;
        }
        (() => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b, _c;
            setIsLoading(true);
            try {
                const response = yield authService.fetch('/graphql', {
                    resourceHostId: 'omnigraph',
                    method: 'POST',
                    body: JSON.stringify({
                        query: WISHLIST_QUERY,
                        variables: {
                            input: {
                                country: localeService.countryCode,
                                limit: 50,
                            },
                        },
                    }),
                    headers: {
                        'Content-Type': 'application/json',
                        'apollographql-client-name': __FEATURE_APP_NAME__,
                        'apollographql-client-version': __FEATURE_APP_VERSION__,
                    },
                });
                const responseJSON = (yield response.json());
                setWishlist((_c = (_b = (_a = responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.data) === null || _a === void 0 ? void 0 : _a.wishlist) === null || _b === void 0 ? void 0 : _b.wishlists) !== null && _c !== void 0 ? _c : []);
            }
            catch (e) {
                setError(e);
            }
            finally {
                setIsLoading(false);
            }
        }))();
    }, [isAuthenticated, isAuthenticating, localeService.countryCode]);
    const contextValue = useMemo(() => ({
        isLoading,
        error,
        wishlist,
        add: (vehicle) => __awaiter(void 0, void 0, void 0, function* () {
            setWishlist((curr) => {
                const newWishlist = [...curr];
                newWishlist.unshift(vehicle);
                return newWishlist;
            });
        }),
        remove: (vehicleId) => __awaiter(void 0, void 0, void 0, function* () {
            setWishlist((curr) => {
                return curr.filter((item) => item.vehicleId !== vehicleId);
            });
        }),
        isInWishlist: (vehicleId) => {
            return !!wishlist.find((item) => item.vehicleId === vehicleId);
        },
    }), [isLoading, error, wishlist]);
    return (React.createElement(MyAudiWishlistContext.Provider, { value: contextValue }, children));
};
export const useMyAudiWishlistContext = () => {
    var _a, _b;
    const { authService, isAuthenticated } = useAuthContext();
    const localeService = useServicesContext().getAdditionalService('gfa:locale-service');
    const notificationDisplayService = useServicesContext().getAdditionalService('notification-display-service');
    const audiContentService = useServicesContext().getAdditionalService('audi-content-service');
    const content = audiContentService.getContent();
    const vtpConfig = (_b = (_a = content === null || content === void 0 ? void 0 : content.fields) === null || _a === void 0 ? void 0 : _a.vtpConfiguration) === null || _b === void 0 ? void 0 : _b.fields;
    const { myAudiWishlist } = vtpConfig !== null && vtpConfig !== void 0 ? vtpConfig : {};
    const i18nNotificationLinkCopy = useI18n({
        id: 'vtp-myaudi-wishlist.notification.wishlist-link.copy',
    });
    const i18nAddSuccessNotification = useI18nBulk({
        title: { id: 'vtp-myaudi-wishlist.notification.add.success.title' },
        copy: { id: 'vtp-myaudi-wishlist.notification.add.success.copy' },
    });
    const i18nAddFailureNotification = useI18nBulk({
        title: { id: 'vtp-myaudi-wishlist.notification.add.failure.title' },
        copy: { id: 'vtp-myaudi-wishlist.notification.add.failure.copy' },
    });
    const i18nRemoveSuccessNotification = useI18nBulk({
        title: { id: 'vtp-myaudi-wishlist.notification.remove.success.title' },
        copy: { id: 'vtp-myaudi-wishlist.notification.remove.success.copy' },
    });
    const i18nRemoveFailureNotification = useI18nBulk({
        title: { id: 'vtp-myaudi-wishlist.notification.remove.failure.title' },
        copy: { id: 'vtp-myaudi-wishlist.notification.remove.failure.copy' },
    });
    const contextValue = useContext(MyAudiWishlistContext);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState();
    return Object.assign(Object.assign({}, contextValue), { isLoading: contextValue.isLoading || isLoading, error: contextValue.error || error, wishlist: contextValue.wishlist, isInWishlist: contextValue.isInWishlist, add: (vehicleId, vehicleCategory) => __awaiter(void 0, void 0, void 0, function* () {
            var _c, _d;
            if (!isAuthenticated) {
                console.error('The app is not authenticated!');
                return;
            }
            setError(undefined);
            setIsLoading(true);
            try {
                const response = yield authService.fetch('/graphql', {
                    resourceHostId: 'omnigraph',
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'apollographql-client-name': __FEATURE_APP_NAME__,
                        'apollographql-client-version': __FEATURE_APP_VERSION__,
                    },
                    body: JSON.stringify({
                        query: ADD_QUERY,
                        variables: {
                            input: {
                                vehicleCategory,
                                vehicleId,
                                country: localeService.countryCode,
                            },
                        },
                    }),
                });
                const responseJSON = (yield response.json());
                if ((_c = responseJSON.errors) === null || _c === void 0 ? void 0 : _c.length) {
                    responseJSON.errors.forEach(console.error);
                    throw new Error('Something went wrong!');
                }
                contextValue.add((_d = responseJSON.data) === null || _d === void 0 ? void 0 : _d.saveWishlist.wishlist);
                notificationDisplayService.closeNotification(NOTIFICATION_ID);
                notificationDisplayService.createNotification(NotificationTypeV1.POPUP_SUCCESS, NOTIFICATION_ID, i18nAddSuccessNotification.copy, {
                    title: i18nAddSuccessNotification.title,
                    textButton: (React.createElement(TextLink, { size: "sm", variant: "standalone", href: myAudiWishlist.path, icon: "external-link", iconPosition: "trailing" }, i18nNotificationLinkCopy)),
                });
            }
            catch (e) {
                setError(e);
                notificationDisplayService.closeNotification(NOTIFICATION_ID);
                notificationDisplayService.createNotification(NotificationTypeV1.POPUP_ERROR, NOTIFICATION_ID, i18nAddFailureNotification.copy, { title: i18nAddFailureNotification.title });
            }
            finally {
                setIsLoading(false);
            }
        }), remove: (vehicleId) => __awaiter(void 0, void 0, void 0, function* () {
            var _e, _f;
            if (!isAuthenticated) {
                console.error('The app is not authenticated!');
                return;
            }
            const wishlistItemId = (_e = contextValue.wishlist.find((item) => item.vehicleId === vehicleId)) === null || _e === void 0 ? void 0 : _e.id;
            if (!wishlistItemId)
                return;
            setError(undefined);
            setIsLoading(true);
            try {
                const response = yield authService.fetch('/graphql', {
                    resourceHostId: 'omnigraph',
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'apollographql-client-name': __FEATURE_APP_NAME__,
                        'apollographql-client-version': __FEATURE_APP_VERSION__,
                    },
                    body: JSON.stringify({
                        query: DELETE_QUERY,
                        variables: {
                            input: {
                                ids: [wishlistItemId],
                                country: localeService.countryCode,
                            },
                        },
                    }),
                });
                const responseJSON = (yield response.json());
                if (!((_f = responseJSON.data) === null || _f === void 0 ? void 0 : _f.deleteWishlist.success)) {
                    throw new Error(responseJSON.data.deleteWishlist.message);
                }
                contextValue.remove(vehicleId);
                notificationDisplayService.closeNotification(NOTIFICATION_ID);
                notificationDisplayService.createNotification(NotificationTypeV1.POPUP_SUCCESS, NOTIFICATION_ID, i18nRemoveSuccessNotification.copy, {
                    title: i18nRemoveSuccessNotification.title,
                    textButton: (React.createElement(TextLink, { size: "sm", variant: "standalone", href: myAudiWishlist.path, icon: "external-link", iconPosition: "trailing" }, i18nNotificationLinkCopy)),
                });
            }
            catch (e) {
                setError(e);
                notificationDisplayService.closeNotification(NOTIFICATION_ID);
                notificationDisplayService.createNotification(NotificationTypeV1.POPUP_ERROR, NOTIFICATION_ID, i18nRemoveFailureNotification.copy, { title: i18nRemoveFailureNotification.title });
            }
            finally {
                setIsLoading(false);
            }
        }) });
};
const WISHLIST_QUERY = `
  query GetWishlist($input: WishlistFilterInput!) {
    wishlist(input: $input) {
      wishlists {
        id
        vehicleId
      }
    }
  }
`;
const ADD_QUERY = `
  mutation SaveWishlistItem($input: SaveWishlistInput!) {
    saveWishlist(input: $input) {
      wishlist {
        id
        vehicleId
      }
    }
  }
`;
const DELETE_QUERY = `
  mutation DeleteWishlistItem($input: DeleteWishlistInput!) {
    deleteWishlist(input: $input) {
      success
      message
    }
  }
`;
const NOTIFICATION_ID = 'vtp-myaudi-wishlist';
